import React, { useState } from "react";
import { Form, Input, Button, Typography, Layout, Card, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import "./Styles/Login.css";
import axios from "axios"; // Import Axios

const { Title } = Typography;
const { Content } = Layout;

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const onFinish = (values) => {
    console.log("Received values of form: ", values);
    axios
      .post(
        //"https://app-nm5xb3nmya-uc.a.run.app/api/login",
        "https://app-tl2d3sc25q-uc.a.run.app/api/login",

        {
          email: values.username,
          password: values.password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then((response) => {
        console.log(response.status);
        if (response.status === 200) {
          console.log(response.data);

          localStorage.setItem("vendor_id", response.data.userId);
          localStorage.setItem("role", response.data.role);
          // If login is successful, call the onLogin function
          message.success("Login successful");
          onLogin();
        } else {
          // If login fails, show an error message
          message.error("Invalid username or password");
        }
      })
      .catch((error) => {
        console.error("API error: ", error);
        message.error("Login failed. Please try again.");
      });
  };

  return (
    <Layout className="login-layout">
      <Content className="login-content">
        <Card className="login-card">
          <Title level={2} className="login-title">
            Login
          </Title>
          <Form
            name="login"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            className="login-form"
          >
            <Form.Item
              name="username"
              rules={[
                { required: true, message: "Please input your Username!" },
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="input-form"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Please input your Password!" },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-form"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                Log in
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
};

export default Login;
